/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1ApiKeysRerollKeyRequestBody = {
  /**
   * API key identifier returned by apiKeys.createKey or apiKeys.listKeys.
   */
  keyId: string;
  /**
   * Milliseconds until the original API key expires. Use 0 to revoke it immediately.
   *
   * @remarks
   * Use null to keep the original key's current expiration. This value never extends
   * an existing expiration.
   */
  expiration: number | null;
};

/** @internal */
export type V1ApiKeysRerollKeyRequestBody$Outbound = {
  keyId: string;
  expiration: number | null;
};

/** @internal */
export const V1ApiKeysRerollKeyRequestBody$outboundSchema: z.ZodType<
  V1ApiKeysRerollKeyRequestBody$Outbound,
  z.ZodTypeDef,
  V1ApiKeysRerollKeyRequestBody
> = z.object({
  keyId: z.string(),
  expiration: z.nullable(z.number().int()),
});

export function v1ApiKeysRerollKeyRequestBodyToJSON(
  v1ApiKeysRerollKeyRequestBody: V1ApiKeysRerollKeyRequestBody,
): string {
  return JSON.stringify(
    V1ApiKeysRerollKeyRequestBody$outboundSchema.parse(
      v1ApiKeysRerollKeyRequestBody,
    ),
  );
}
